<template>
  <v-app theme="light" style="background-color: #eeeeee">
	<nav-bar :menuItems="[]" :portalButton="false" hideNotifications />
    <VMain>
		<v-container>
			<v-form v-model="valid">
				<v-row class="contentRow">
					<v-col>
						<h1 class="mb-2">Password Reset</h1>
						<p class="mb-4 text-center">Please choose a new password in order to use Orixe.</p>
					</v-col>
				</v-row>
				<v-row class="contentRow">
					<v-col cols="12" sm="4">
						<v-text-field
							:append-icon="showOld ? 'fas fa-eye' : 'fas fa-eye-slash'"
							:rules="[rules.required]"
							:type="showOld ? 'text' : 'password'"
							v-model="oldpassword"
							label="Old Password"
							hint="Enter your current password"
							class="input-group--focused"
							autocomplete="current-password"
							@click:append="showOld = !showOld"
						></v-text-field>
					</v-col>
					<v-col cols="12" sm="4">
						<secure-password-field
							:append-icon="showNew ? 'fas fa-eye' : 'fas fa-eye-slash'"
							:visible="showNew"
							v-model="newpassword"
							label="New Password"
							class="input-group--focused"
							:rejection-errors="passwordRejectionErrors"
							@click:append="showNew = !showNew"
						/>
					</v-col>
					<v-col cols="12" sm="4">
						<secure-password-field
							:append-icon="showConfirm ? 'fas fa-eye' : 'fas fa-eye-slash'"
							:visible="showConfirm"
							v-model="confirmpassword"
							label="Confirm New Password"
							class="input-group--focused"
							:show-guidance="false"
							:enforce-policy="false"
							:rules="[rules.confirmMatch]"
							@click:append="showConfirm = !showConfirm"
						/>
					</v-col>
				</v-row>
			</v-form>
			<v-row class="contentRow">
				<v-col cols="12" sm="4">
					<v-btn :disabled="!valid" color="primary" @click="changePassword">Reset Password</v-btn>
				</v-col>
			</v-row>

			<v-dialog v-model="loader" hide-overlay persistent width="300">
				<v-card color="secondary" dark>
					<v-card-text>
						<p class="pt-3 text-center">Changing your password...</p>
						<ssc-loader />
					</v-card-text>
				</v-card>
			</v-dialog>
		</v-container>
    </VMain>
    <test-error />
  </v-app>
</template>


<script>
import api from "../../api/api"
import router from "../../router"
import LoadingState from "../../consts/LoadingState"
import store from "../../store"
import SecurePasswordField from "../../components/SecurePasswordField.vue"

export default {
	components: { SecurePasswordField },
	data() {
		return {
			oldpassword: null,
			newpassword: null,
			confirmpassword: null,
			showOld: false,
			showNew: false,
			showConfirm: false,
			loader: false,
			interval: null,
			valid: false,
			passwordRejectionErrors: [],
			rules: {
				required: (value) => !!value || "Required.",
				confirmMatch: ()=>true
			}
		}
	},
	created() {
		this.rules.confirmMatch = () => this.newpassword == this.confirmpassword || "Confirm password does not match new password."
	},
	methods: {
		changePassword() {
			this.loader = true
			Promise.all([
				this.setNewPassword(),
				store.dispatch("user/verifyLogin"),
				new Promise((resolve, reject)=>{
					this.interval = setInterval(()=>{
						if (store.getters["user/forcePasswordReset"] == false) {
							clearInterval(this.interval)
							resolve()
						} else {
							store.dispatch("user/verifyLogin")
								.catch((err)=>{
									clearInterval(this.interval)
									reject(err)
								})
						}
					}, 1000)
				})
			])
				.then(() => {
					clearInterval(this.interval)
					this.loader = false
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_LOADING_SUCCESS,
						"Password was successfully reset!",
						{ root: true }
					)
					router.push("/")
				})
				.catch(error => {
					clearInterval(this.interval)
					this.loader = false
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		},
		setNewPassword() {
			return new Promise((resolve, reject)=>{
				api.put("/users/current/password", {
					oldpassword: this.oldpassword,
					newpassword: this.newpassword,
					confirmpassword: this.confirmpassword
				})
					.then(value => {
						if (!value.data || !value.data.error || !value.data.data) {
							throw new Error("Could not get response!")
						}
						if (value.data.error.length > 0) {
							const err = value.data.error[0]
							if (err.details && err.details.length) {
								this.passwordRejectionErrors = err.details
							}
							return reject(err.message)
						}
						return resolve()
					})
					.catch(err => {
						reject(err)
					})
			})
		}
	},
	computed: {
		isValid() {
			return this.$refs.form.validate()
		}
	}
}
</script>